export default "__VITE_ASSET__ac282b6d__"